import { defineStore } from 'pinia'
import { getRouteQueryValue } from '@/utils'

const resolveUserIdFromRoute = (): string => {
  const params = new URLSearchParams(window.location.search)
  const query = Object.fromEntries(params.entries())
  return (getRouteQueryValue(query, 'id', 'userid', 'userId') as string) || ''
}

const useUserStore = defineStore('user', {
  state: () => ({
    id: resolveUserIdFromRoute(),
    userId: resolveUserIdFromRoute(),
    name: '',
    avatar: '',
    roles: [] as string[],
    permissions: [] as string[],
    orgId: undefined as string | number | undefined,
  }),
  actions: {
    setCurrentIMUser(data: { userId?: string; sig?: string }): void {
      if (data.userId) {
        this.userId = data.userId
        this.id = data.userId
      }
    },
  },
})

export default useUserStore
